import {
  loan_application,
  LoanApplicationDocument,
} from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const getLoanApplicationDocuments =
  (api: IAPI) =>
  async (
    applicationID: string
  ): Promise<loan_application.LoanApplicationDocument[]> =>
    send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/documents`,
      token: api.token,
      method: 'GET',
    });

export const postLoanApplicationDocument =
  (api: IAPI) =>
  async ({
    applicationID,
    filename,
    category,
  }: {
    applicationID: string;
    filename: string;
    category: loan_application.DocumentCategory;
  }): Promise<loan_application.LoanApplicationDocument> =>
    send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/documents`,
      token: api.token,
      method: 'POST',
      body: { Filename: filename, Category: category },
    });

export const getLoanApplicationDocument =
  (api: IAPI) =>
  async ({
    applicationID,
    documentID,
  }: {
    applicationID: string;
    documentID: string;
  }): Promise<string> =>
    send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/documents/${documentID}`,
      token: api.token,
      method: 'GET',
    });

export const patchLoanApplicationDocument =
  (api: IAPI) =>
  async ({
    applicationID,
    documentID,
    data,
  }: {
    applicationID: string;
    documentID: string;
    data: Partial<LoanApplicationDocument>;
  }): Promise<string> =>
    send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/documents/${documentID}`,
      token: api.token,
      method: 'PATCH',
      body: data,
    });

export const deleteLoanApplicationDocument =
  (api: IAPI) =>
  async (applicationID: string, documentID: string): Promise<string> =>
    send({
      baseURL: api.url.service,
      path: `/loan-application/${applicationID}/documents/${documentID}`,
      token: api.token,
      method: 'DELETE',
    });
